/*
===============================================================================
Helpers: jQuery
===============================================================================
*/

$.fn.reverse = function( ) {
	return this.pushStack( this.get( ).reverse( ), arguments );
};

$.fn.serializeObject = function( ) {
	var o = { },
		a = this.serializeArray( );

	$.each( a, function( ) {
		if ( o[ this.name ] !== undefined ) {
			if ( !o[ this.name ].push ) {
				o[ this.name ] = [ o[ this.name ] ];
			}

			o[ this.name ].push( this.value || '' );
		}
		else {
			o[ this.name ] = this.value || '';
		}
	} );

	return o;
};

$.fn.isolatedScroll = function( ) {
	this.on( 'mousewheel DOMMouseScroll', function( aEvent ) {
		var delta = aEvent.wheelDelta || ( aEvent.originalEvent && aEvent.originalEvent.wheelDelta ) || -aEvent.detail,
			bottomOverflow = this.scrollTop + $( this ).outerHeight( ) - this.scrollHeight >= 0,
			topOverflow = this.scrollTop <= 0;

		if ( $( this ).outerHeight( ) != this.scrollHeight && ( ( delta < 0 && bottomOverflow ) || ( delta > 0 && topOverflow ) ) ) {
			aEvent.preventDefault( );
		}
	} );

	return this;
};

$.fn.isOnScreen = function( aScreen ) {
	var win = $( aScreen || window ),
		vt = win.scrollTop( ),
		vl = win.scrollLeft( ),
		vr = vl + win.width( ),
		vb = vt + win.height( ),
		eb = this.offset( );

	if ( !eb ) {
		return false;
	}

	if ( eb.top < 0 ) {
		eb.top = Math.abs( eb.top );
	}

	eb.right = eb.left + this.outerWidth( );
	eb.bottom = eb.top + this.outerHeight( );

	return ( !( vr < eb.left || vl > eb.right || vb < eb.top || vt > eb.bottom ) );
};

$.fn.getStyle = function( aProperty ) {
	var styles = this.attr( 'style' ),
		value = false;

	if ( styles !== undefined ) {
		styles.split( ';' ).forEach( function( e ) {
			var style = e.split( ':' );

			if ( $.trim( style[ 0 ] ) === aProperty ) {
				value = style[ 1 ];
			}
		} );
	}

	return value;
};

$.fn.removeStyle = function( aStyle ) {
	var search = new RegExp( aStyle + '[^;]+;?', 'g' );

	return this.each( function( ) {
		$( this ).attr( 'style', function( i, style ) {
			return ( style !== undefined ) ? style.replace( search, '' ) : '';
		} );
	} );
};

$.fn.enable = function( ) {
	this.prop( 'disabled', false );
	this.removeClass( 'disabled' );

	return this;
};

$.fn.disable = function( ) {
	this.prop( 'disabled', true );
	this.addClass( 'disabled' );

	return this;
};

$.fn.loading = function( aEnable ) {
	var enable = aEnable || false,
		loading, contents, i, len;

	if ( this.is( '.btn' ) === true ) {
		loading = this.find( '.loader' );

		if ( enable === true && loading.length === 0 ) {
			loading = $( '<div class="loader"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve"><rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2"><animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect><rect x="8" y="10" width="4" height="10" fill="#333" opacity="0.2"><animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect><rect x="16" y="10" width="4" height="10" fill="#333" opacity="0.2"><animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate><animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>' );

			// .btn-loading children are opacity 0, so text node children need to be wrapped
			contents = this.contents( );
			for ( i = 0, len = contents.length; i < len; i++ ) {
				if ( contents[ i ].nodeType === 3 ) {
					$( contents[ i ] ).wrap( '<span class="loader-hidden"></span>' );
				}
			}

			this.addClass( 'btn-loading' );
			this.append( loading );
		}
		else if ( enable === false ) {
			this.find( '.loader-hidden' ).contents( ).unwrap( );

			this.removeClass( 'btn-loading' );
			loading.remove( );
		}
	}

	return this;
};

$.fn.disableSelect = function( ) {
	this.attr( 'unselectable', 'on' );
	this.on( 'selectstart.cinder-disableselect', false );

	if ( this.is( 'img' ) === true ) {
		this.on( 'dragstart.cinder-disableselect', false );
	}
};

$.fn.enableSelect = function( ) {
	this.removeAttr( 'unselectable' );
	this.off( 'selectstart.cinder-disableselect' );

	if ( this.is( 'img' ) === true ) {
		this.off( 'dragstart.cinder-disableselect' );
	}
};

var _jquery_original_val = $.fn.val;

$.fn.val = function( aValue, aEvent ) {
	var ret = _jquery_original_val.apply( this, arguments ),
		evt = aEvent || false;

	if ( aValue !== undefined && evt !== false ) {
		this.trigger( 'change' );
	}

	return ret;
};

$.fn.zoom = function( ) {
	var transform, current;

	transform = this[ 0 ].style.transform || this[ 0 ].style.wekbitTransform || this[ 0 ].style.msTransform || '';

	if ( transform.match( 'scale\([0-9]*\)' ) == null ) {
		return 1;
	}

	current = $.parseFloat( transform.replace( /scale\(([0-9.]*)\)/, '$1' ) );

	return current;
};

$.fn.appendDropdownTo = function( aElement ) {
	return this.each( function( ) {
		var button = $( this ),
			parent = button.parent( ),
			className = parent[ 0 ].className;

		button.parent( ).on( 'show.bs.dropdown', function( aEvent ) {
			var container = document.createElement( 'div' ),
				$container = $( container ),
				dropdown = button.siblings( '.dropdown-menu' ),
				offset;

			if ( button.parentsUntil( aElement ).length > 0 ) {
				offset = {
					top: button.offset( ).top - $( aElement ).offset( ).top,
					left: button.offset( ).left - $( aElement ).offset( ).left
				};
			}
			else {
				offset = button.offset( );
			}

			container.className = className + ' float open';

			if ( $container.hasClass( 'dropup' ) ) {
				$container.css( {
					left: offset.left + button.outerWidth( true ),
					top: offset.top,
					position: 'absolute'
				} );
			}
			else {
				$container.css( {
					left: ( button.outerWidth( true ) + offset.left ) - dropdown.outerWidth( true ),
					top: offset.top + button.outerHeight( true ),
					position: 'absolute'
				} );
			}

			$container.append( dropdown );

			$( aElement ).append( $container );
		} );

		button.parent( ).on( 'hide.bs.dropdown', function( aEvent ) {
			var dropdown = $( aElement ).find( '> div.float > .dropdown-menu' );

			dropdown.unwrap( );

			parent.append( dropdown );
		} );
	} );
};

$.fn.overlaps = function( aTargets ) {
	var element = $( this ),
		offset = element.offset( ),
		tx = [ offset.left, offset.left + element.outerWidth( ) ],
		ty = [ offset.top, offset.top + element.outerHeight( ) ],
		targets = $( aTargets ),
		intersects = false,
		item, pos, ix, iy,
		i, len;

	for ( i = 0, len = targets.length; i < len; i++ ) {
		item = $( targets[ i ] );
		pos = item.offset( );
		ix = [ pos.left, pos.left + item.outerWidth( ) ];
		iy = [ pos.top, pos.top + item.outerHeight( ) ];

		if ( tx[ 0 ] < ix[ 1 ] && tx[ 1 ] > ix[ 0 ] && ty[ 0 ] < iy[ 1 ] && ty[ 1 ] > iy[ 0 ] ) {
			intersects = true;
			break;
		}
	}

	return intersects;
};

$.fn.clamp = function( aLines ) {
	var html, char, lh, max, j, len2, chunks, i, len, old, el;

	for ( j = 0, len2 = $( this ).length; j < len2; j++ ) {
		el = this[ j ];

		lh = parseInt( window.getComputedStyle( el ).lineHeight, 10 ) + 2;
		max = lh * aLines;

		html = '';
		char = false;

		if ( el.scrollHeight <= max ) { //Check if container needs to be clamped
			continue;
		}
		else {
			chunks = el.innerHTML.split( /(?=\s)/ );

			len = chunks.length;

			//Save original html content/string in an attribute
			$( el ).attr( 'data-clamp-content', el.innerHTML );

			if ( len > 1 ) { //Check if container can be clamped by word
				old = el.innerHTML;

				for ( i = 0; i < len; i++ ) {
					html += chunks[ i ];

					el.innerHTML = html;

					// Stop clamping if height exceeds max
					if ( el.offsetHeight > max ) {
						char = true;

						break;
					}
				}
			}
			else {
				char = true;
			}

			//Clamp by character
			if ( char === true ) {
				old = el.innerHTML;
				len = old.length;

				i = 0;

				while ( i < len ) {
					el.innerHTML = old.substring( 0, len ).replace( /\s+$/, '' ) + '\u2026';

					if ( el.scrollHeight <= max ) {
						break;
					}

					len--;
				}
			}

			continue;
		}
	}
};

$.fn.unclamp = function( ) {
	var i, len, el, data_content;

	for ( i = 0, len = $( this ).length; i < len; i++ ) {
		el = this[ i ];
		data_content = $( el ).attr( 'data-clamp-content' );

		//Check if container can be unclamped. Elements can only be unclamp if it was previously clamped
		if ( data_content === undefined ) {
			continue;
		}
		else {
			el.innerHTML = data_content;
			$( el ).removeAttr( 'data-clamp-content' );
		}
	}
};

$.fn.copyDataSet = function( aTargets ) {
	var el = $( this ),
		targets = $( aTargets ),
		i, len, j, len2, attribute;

	for ( i = 0, len = targets.length; i < len; i++ ) {
		for ( j = 0, len2 = targets[ i ].attributes.length; j < len2; j++ ) {
			attribute = targets[ i ].attributes[ j ];

			if ( /^data-/.test( attribute.name ) ) {
				el.attr( attribute.name, targets[ i ].getAttribute( attribute.name ) );
			}
		}
	}
};

$.getDataSet = function( aTargets ) {
	var data = { },
		targets = $( aTargets ),
		i, len, j, len2, attribute;

	for ( i = 0, len = targets.length; i < len; i++ ) {
		for ( j = 0, len2 = targets[ i ].attributes.length; j < len2; j++ ) {
			attribute = targets[ i ].attributes[ j ];

			if ( /^data-/.test( attribute.name ) ) {
				data[ attribute.name ] = targets[ i ].getAttribute( attribute.name );
			}
		}
	}

	return data;
};

$.rgbToHex = function( aRgb ) {
	var rgb;

	if ( aRgb === undefined || aRgb === null ) {
		return aRgb;
	}

	if ( typeof aRgb === 'object' ) {
		rgb = [ ];

		rgb[ 0 ] = parseInt( aRgb.r, 10 );
		rgb[ 1 ] = parseInt( aRgb.g, 10 );
		rgb[ 2 ] = parseInt( aRgb.b, 10 );
	}
	else {
		if ( aRgb.indexOf( 'rgb(' ) === -1 ) {
			return aRgb;
		}

		rgb = aRgb.replace( /[^0-9,]/g, '' ).split( ',' );

		rgb[ 0 ] = parseInt( rgb[ 0 ], 10 );
		rgb[ 1 ] = parseInt( rgb[ 1 ], 10 );
		rgb[ 2 ] = parseInt( rgb[ 2 ], 10 );
	}

	return '#' + ( ( 1 << 24 ) + ( rgb[ 0 ] << 16 ) + ( rgb[ 1 ] << 8 ) + rgb[ 2 ] ).toString( 16 ).substr( 1 );
};

$.hexToRgb = function( aHex ) {
	var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( aHex );

	return result ? {
		r: parseInt( result[ 1 ], 16 ),
		g: parseInt( result[ 2 ], 16 ),
		b: parseInt( result[ 3 ], 16 )
	} : null;
};

$.isNode = function( aNode ) {
	return typeof Node === 'object' ? aNode instanceof Node : aNode && typeof aNode === 'object' && typeof aNode.nodeType === 'number' && typeof aNode.nodeName === 'string';
};

$.isElement = function( aElement ) {
	return typeof HTMLElement === 'object' ? aElement instanceof HTMLElement : aElement && typeof aElement === 'object' && aElement !== null && aElement.nodeType === 1 && typeof aElement.nodeName === 'string';
};

$.debounce = function( aFunction, aDelay ) {
	var delay = aDelay || 10,
		timeout;

	return function( ) {
		var args = arguments,
			self = this,
			callback;

		callback = function( ) {
			timeout = null;

			aFunction.apply( self, args );
		};

		if ( timeout !== undefined ) {
			clearTimeout( timeout );
		}

		timeout = setTimeout( callback, delay );
	};
};

$.convertHyphensToUnderscores = function( aObject ) {
	var obj = { },
		i, k;

	for ( i in aObject ) {
		if ( aObject.hasOwnProperty( i ) === true ) {
			k = i;

			if ( k.indexOf( '-' ) !== -1 ) {
				k = k.replace( '-', '_' );
			}

			obj[ k ] = aObject[ i ];
		}
	}

	return obj;
};

$.parseFloat = function( aValue ) {
	var value = parseFloat( aValue );

	return isNaN( value ) ? 0 : value;
};

$.round = function( aValue ) {
	return Math.round( ( aValue + 0.00001 ) * 100 ) / 100;
};

$.isUrl = function( aUrl ) {
	return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( aUrl );
};

$.formatCurrency = function( aNumber, aSymbol, aFormat ) {
	var number = parseFloat( aNumber ),
		s = ( number < 0 ) ? '-' : '',
		i = parseInt( number = $.round( Math.abs( +number || 0 ) ) ) + '',
		j = ( j = i.length ) > 3 ? j % 3 : 0,
		m = ( aSymbol !== undefined ) ? aSymbol : '$',
		f = aFormat || ',.%s%v',
		t_sep = f.substr( 0, 1 ),
		d_sep = f.substr( 1, 1 ),
		d, paddedDecimal, val;

	d = Math.round( number * 100 ) % 100;

	if ( d === 0 ) {
		paddedDecimal = '00';
	}
	else if ( d < 10 ) {
		paddedDecimal = '0' + d;
	}
	else {
		paddedDecimal = d + '';
	}

	val = ( j ? i.substr( 0, j ) + t_sep : '' ) + i.substr( j ).replace( /(\d{3})(?=\d)/g, '$1' + t_sep ) + d_sep + paddedDecimal;

	f = f.substr( 2 );

	return s + f.replace( '%s', m ).replace( '%v', val );
};

/**
 * Removes currency format from a given string
 *
 * Optional second param to return the affix strings for the value instead
 *
 * @param {String}	aValue 	String to remove currency format from
 * @param {Boolean}	aSplit	Whether or not to return affix values (append/prepend strings) for aValue instead
 *
 * @return Mixed
 */

$.removeCurrencyFormat = function( aValue, aSplit ) {
	var val = aValue,
		d_pos, d_sep, parts, thousands, decimals, negative;

	// Remove non-ascii characters
	val = val.replace( /[^\x00-\x80]/g, '' );

	// Remove non-digits from the front & end of the string
	val = val.replace( /^(-)?[^0-9-]*/, '$1' );
	val = val.replace( /[^0-9]*$/, '' );

	if ( $.isNumeric( val.replace( /[^0-9-]/g, '' ) ) == false ) {
		return aValue;
	}

	negative = ( val.substr( 0, 1 ) == '-' ) ? '-' : '';

	if ( negative + '' !== '' ) {
		val = val.substr( 1 );
	}

	if ( aSplit === true ) {
		return aValue.split( val );
	}

	// In cases where we have a - and currency on the left, remove the currency
	val = val.replace( /^[^0-9]*/, '' );

	d_pos = -3;
	d_sep = val.substr( d_pos, 1 );

	if ( d_sep.match( /[^0-9]/ ) == null ) {
		d_pos++;
		d_sep = val.substr( d_pos, 1 );
	}

	if ( d_sep.match( /[^0-9]/ ) !== null ) {
		parts = [
			val.substr( 0, val.length + d_pos ),
			val.substr( ( d_pos + 1 ), 2 )
		];
	}
	else {
		parts = [ val ];
	}

	// Format thousands for JS math
	thousands = parts[ 0 ].replace( /[^0-9]/g, '' );
	// Decide what decimal to add
	decimals = ( parts.length > 1 ) ? parts[ 1 ] : '00';

	return $.parseFloat( negative + thousands + '.' + decimals );
};

$.currencyDecimalFormat = function( aValue, aRemoveAll ) {
	var remove_all = aRemoveAll || false,
		regex;

	if ( remove_all == true ) {
		regex = /[^0-9][0-9][0-9]([^0-9]+)?$/;
	}
	else {
		regex = /[^0-9]00([^0-9]+)?$/;
	}

	return aValue.replace( regex, '$1' );
};

$.pluralize = function( aWord, aCount ) {
	// Note that this is a very simple rule below and will not handle words like 'fox|es' or 'octopus' etc but we have very few in-app foxes/octopi,
	// but will handle regular words like 'fee' or 'day' to become: 0 fees (0 days), 1 fee (1 day), 2 fees (2 days), etc.
	return ( parseInt( aCount, 10 ) !== 1 ) ? aWord + 's' : aWord;
};

var _getClass = function( val ) {
	return Object.prototype.toString.call( val ).match( /^\[object\s(.*)\]$/ )[ 1 ];
};

var _getType = function( val ) {
	var type;

	if ( val === undefined ) {
		return 'undefined';
	}
	else if ( val === null ) {
		return 'null';
	}

	type = typeof val;

	if ( type === 'object' ) {
		type = _getClass( val ).toLowerCase( );
	}

	if ( type === 'number' ) {
		if ( val.toString( ).indexOf( '.' ) > 0 ) {
			return 'float';
		}
		else {
			return 'integer';
		}
	}

	return type;
};

var _compareObject = function( a, b ) {
	var i;

	if ( a === b ) {
		return true;
	}

	for ( i in a ) {
		if ( b.hasOwnProperty( i ) === true ) {
			if ( $.equal( a[ i ], b[ i ] ) === false ) {
				return false;
			}
		}
		else {
			return false;
		}
	}

	for ( i in b ) {
		if ( a.hasOwnProperty( i ) === false ) {
			return false;
		}
	}

	return true;
};

var _compareArray = function( a, b ) {
	var i, len;

	if ( a === b ) {
		return true;
	}

	if ( a.length !== b.length ) {
		return false;
	}

	for ( i = 0, len = a.length; i < len; i++ ) {
		if ( $.equal( a[ i ], b[ i ] ) === false ) {
			return false;
		}
	}

	return true;
};

var _equal = {
	'array': _compareArray,
	'object': _compareObject,
	'date': function( a, b ) {
		return a.getTime( ) === b.getTime( );
	},
	'regexp': function( a, b ) {
		return a.toString( ) === b.toString( );
	},
	'function': function( a, b ) {
		return a.toString( ) === b.toString( );
	}
};

$.equal = function( a, b ) {
	var atype, btype;

	if ( a !== b ) {
		atype = _getType( a );
		btype = _getType( b );

		if ( atype === btype ) {
			return _equal.hasOwnProperty( atype ) ? _equal[ atype ]( a, b ) : a === b;
		}

		return false;
	}

	return true;
};

$.isEmptyObject = function( obj ) {
	return ( Object.keys( obj ).length === 0 && obj.constructor === Object );
};

$.fn.string = function( aText ) {
	var text = aText || '',
		els = $( this ),
		el, i, len;

	for ( i = 0, len = els.length; i < len; i++ ) {
		el = $( els[ i ] );

		if ( el.is( 'p, span, label, h1, h2, h3, h4, h5, h6, a, button' ) === true ) {
			el.html( text );
		}
		else if ( el.is( 'input[type="text"]' ) === true || el.is( 'textarea' ) === true ) {
			el[ i ].setAttribute( 'placeholder', text );
		}
	}
};

/**
 * Handles blur on arbitrary element by checking for clicks elsewhere in the document
 *
 * @param {Function} aCallback
 * @param {DOMElement} aTargets (Optional) Additional targets to check against for denying the blur event
 *
 * @return {DOMElement}
 */

$.fn.elementBlur = function( aCallback, aTargets ) {
	var callback = ( $.isFunction( aCallback ) === true ) ? aCallback : function( ) { },
		targets = aTargets || $( ),
		elements = targets.add( this );

	$( window ).off( 'mousedown.elementBlur' ).on( 'mousedown.elementBlur', function( aEvent ) {
		var target = $( aEvent.target ),
			el;

		el = ( target.is( elements ) === true ) ? target : target.closest( elements );

		if ( el.length === 0 ) {
			$( window ).off( 'mousedown.elementBlur' );

			callback( aEvent );
		}
	} );

	return this;
};

/**
 * Handles loaded callbacks for image elements
 *
 * @param {Function}	aCallback	Callback function for this is loaded
 */
$.fn.onLoaded = function( aCallback ) {
	var callback = aCallback || function( ) { },
		els = $( this ),
		i, len, src;

	els.one( 'load', callback );

	for ( i = 0, len = els.length; i < len; i++ ) {
		// img elements with no src set (at this precise point) will report 'complete' immediately,
		// so ignore those with no src. Safari seems to have a problem where if 'src' is blank,
		// the .src attribute can return wrongly (it results in the URL for page instead), whereas
		// attr( 'src' ) works.
		src = els.eq( i ).attr( 'src' );

		if ( els[ i ].complete === true && src !== '' && src !== undefined ) {
			els.eq( i ).trigger( 'load' );
		}
	}

	return this;
};

/**
 * USE_PRINCE_HTML_ENTITY_WORKAROUND
 *
 * Boolean flag that is use to know if we need to perform the prince html entity work around
 * Use this until https://www.princexml.com/forum/3/bugs is fixed
 */

$.USE_PRINCE_HTML_ENTITY_WORKAROUND = false;

/**
 * Replaces the value in a node, trying to maintain nested tags
 *
 * @param {String}	aValue 	Value to put in node
 * @param {String}	aIgnore	CSS Selector of elements to 'ignore' when replaceing.
 * 					Performs a detach then an append on matched elements
 */

$.fn.replaceValue = function( aValue, aIgnore ) {
	var els = $( this ),
		value = aValue || '',
		ignore = aIgnore || '',
		i, len, tags, index,
		ignored;

	if ( value + '' !== '' ) {
		for ( i = 0, len = els.length; i < len; i++ ) {
			ignored = els.eq( i ).find( ignore ).detach( );

			tags = els[ i ].innerHTML.match( /<.*?>/g );

			if ( tags !== null ) {
				index = tags.length / 2;

				tags.splice( index, 0, value );
				tags = tags.join( '' );

				// use replaceNode to update node value until prince fix https://www.princexml.com/forum/3/bugs
				if ( $.USE_PRINCE_HTML_ENTITY_WORKAROUND === true ) {
					$( els[ i ] ).replaceNode( tags );
				}
				else {
					els[ i ].innerHTML = tags;
				}
			}
			// use replaceNode to update node value until prince fix https://www.princexml.com/forum/3/bugs
			else if ( $.USE_PRINCE_HTML_ENTITY_WORKAROUND === true ) {
				$( els[ i ] ).replaceNode( value );
			}
			else {
				els[ i ].innerHTML = value;
			}

			els.eq( i ).append( ignored );
		}
	}

	return els;
};

/**
 * replaceNode
 *
 * Replaces the entire node. Will keep the same open/close tag and just change the value/content. We do thi cause prince has issue
 * rendering dom/node when we do innerHTML change we can remove this when prince release the fix for the bug in the link below
 * https://www.princexml.com/forum/3/bugs
 *
 * @param {String}	aValue 	Value to put in node
 */

$.fn.replaceNode = function( aValue ) {
	var els = $( this ),
		value = aValue || '',
		i, len, j, len2, attrs, string_attr,
		open_tag, close_tag, node_name;

	for ( i = 0, len = els.length; i < len; i++ ) {
		attrs = els[ i ].attributes;
		string_attr = [ ];

		for ( j = 0, len2 = attrs.length; j < len2; j++ ) {
			string_attr.push( attrs[ j ].nodeName + '="' + attrs[ j ].value + '"' );
		}

		node_name = els[ i ].tagName.toLowerCase( );
		open_tag = '<' + node_name + ( ( string_attr.length > 0 ) ? ' ' + string_attr.join( ' ' ) : '' ) + '>';
		close_tag = '</' + node_name + '>';

		$( els[ i ] ).replaceWith( open_tag + value + close_tag );
	}
};

/**
 * Get pricing table row data
 *
 * @param {DOMElement}	aRow 	Row to pull pricing info from
 *
 * @return {JSONObject}
 */

$.pricingRowData = function( aRow ) {
	var row = $( aRow ),
		data = {
			type: false,
			price: false,
			quantity: false,
			total: false,
			original_total: false,
			discount: false
		},
		properties = { },
		subtotal = false,
		cells, input, span, value;

	if ( row.is( 'tr' ) === true ) {
		cells = row.find( '> td' );

		data.quantity = 1;
		data.type = parseInt( row[ 0 ].getAttribute( 'data-format' ), 10 );
		data.included = true;

		// Do not extract pricing from content rows
		if ( data.type !== 6 ) {
			data.total = false;

			// Check optional
			if ( parseInt( row[ 0 ].getAttribute( 'data-optional' ), 10 ) === 1 ) {
				input = cells.first( ).find( 'input[type="checkbox"]' );
				data.included = false;

				if ( input.length > 0 && ( input.is( ':checked' ) === true || input[ 0 ].checked === true || input[ 0 ].hasAttribute( 'checked' ) === true ) ) {
					data.included = true;
				}
			}

			// Get subtotal
			if ( cells.length > 0 ) {
				// If typeable span exists, get value from it
				span = cells.last( ).find( 'span.fr-immutable.fr-typeable' );

				if ( span.length > 0 ) {
					subtotal = $.removeCurrencyFormat( span[ 0 ].textContent );
				}
				else {
					subtotal = $.removeCurrencyFormat( cells.last( )[ 0 ].textContent );
				}
			}

			// Grab price
			if ( data.type === 1 ) {
				data.price = subtotal;
			}
			else if ( cells.length > 1 ) {
				data.price = $.removeCurrencyFormat( cells[ 1 ].textContent );
			}

			// Determine quantity
			if ( data.type !== 1 ) {
				input = cells.eq( 2 ).find( 'input[type="text"]' );

				if ( input.length > 0 ) {
					data.quantity = $.parseFloat( input.val( ) );

					if ( data.quantity + '' === '' || isNaN( data.quantity ) === true ) {
						data.quantity = 0;
					}
				}
				else if ( cells.length > 2 ) {
					data.quantity = cells[ 2 ].textContent.replace( /[^0-9\.]+/g, '' );

					if ( data.quantity + '' === '' || isNaN( data.quantity ) === true ) {
						data.quantity = 1;
					}
				}
			}

			// Get inline discount
			if ( row[ 0 ].hasAttribute( 'data-properties' ) === true ) {
				properties = JSON.parse( row[ 0 ].getAttribute( 'data-properties' ) );
			}

			if ( properties.hasOwnProperty( 'discount' ) === true ) {
				data.discount = properties.discount;
			}

			// Catches
			if ( isNaN( data.price ) === true || data.price + '' === '' || ( typeof data.price === 'string' && data.price.trim( ) === '' ) ) {
				data.price = false;
			}

			if ( isNaN( data.quantity ) === true || data.quantity + '' === '' || ( typeof data.quantity === 'string' && data.quantity.trim( ) === '' ) ) {
				data.quantity = false;
			}

			// Set data.total
			if ( data.price !== false && data.quantity !== false ) {
				data.total = data.price * data.quantity;
			}
			else {
				data.total = subtotal;
			}

			// set original total
			data.original_total = data.total;

			if ( isNaN( data.total ) === true || data.total + '' === '' || typeof data.total !== 'number' ) {
				data.total = false;
				data.original_total = data.total;
			}

			// calculate inline discount
			if ( data.total !== false && properties.hasOwnProperty( 'discount' ) === true ) {
				if ( properties.discount.enable === true && ( properties.discount.value + '' !== '' && isNaN( properties.discount.value ) === false ) && properties.discount.type + '' !== '' ) {
					data.discount.value = properties.discount.value;
					value = parseFloat( data.discount.value );

					if ( properties.discount.type === '%' ) {
						// if discount is over 100 set value to 0
						if ( value > 100 ) {
							data.total = 0;
						}
						else if ( value > 0 ) {
							data.total = data.total * ( ( 100 - value ) / 100 );
						}
					}
					else if ( properties.discount.type === '$' ) {
						// if discount is over than the pre discounted value then set value to 0
						if ( value > data.total ) {
							data.total = 0;
						}
						else if ( value > 0 ) {
							data.total -= value;
						}
					}

				}
			}
		}
	}

	return data;
};

/**
 * Formats a fee table row
 *
 * Abstracted for use in both editor & PDF
 *
 * @param {JSONObject}	aData 	Object of data needed: strings(month, hour, year), currency, format
 */

$.fn.formatPricingRow = function( aData ) {
	var els = $( this ),
		data = aData || { },
		has_strings = ( data.hasOwnProperty( 'strings' ) === true ) ? true : false,
		typeable = '',
		i, len, info, val, input, processed_val, label, spans, span, el, cell, properties, subtotal_string,
		parts, prepend, append, currency, ignored;

	if ( data.hasOwnProperty( 'currency' ) === true && data.hasOwnProperty( 'format' ) === true ) {
		for ( i = 0, len = els.length; i < len; i++ ) {
			// Get inline discount
			if ( els[ i ].hasAttribute( 'data-properties' ) === true ) {
				properties = JSON.parse( els[ i ].getAttribute( 'data-properties' ) );

				if ( properties.hasOwnProperty( 'discount' ) === true ) {
					//check and fix broken inline discount markup if row has inline discount property
					if ( properties.discount.enable === true ) {
						cell = $( els[ i ] ).find( 'td:last-of-type' );
						// remove markers before formatting subtotal cell
						ignored = cell.find( 'div.rowmenu, span.fr-marker' ).detach( );

						if ( ignored.length > 0 ) {
							// Normalize element, otherwise text could be split into multiple nodes
							cell[ 0 ].normalize( );
						}

						// wrap textnodes with immutable/typeable spans. there are instances that user deletes the immutable/typeable spans.
						cell.find( '> p' ).contents( ).filter( function( ) {
							return ( this.nodeType === 3 ) ? true : false;
						} ).wrap( '<span class="fr-immutable fr-typeable"></span>' );

						span = cell.find( 'span.fr-immutable.fr-typeable' );

						if ( span.length !== 0 ) {
							typeable = $.removeCurrencyFormat( span[ 0 ].textContent );
						}

						if ( parseInt( els[ i ].getAttribute( 'data-format' ), 10 ) === 1 && ( span.length === 0 || isNaN( typeable ) === true || typeable + '' === '' || typeof typeable !== 'number' ) ) {
							// add blank fr-typeable span for fix row, otherwise user can no longer type into the subtotal cell of a fixed row
							cell.html( '<p>0</p>' );
						}

						// add markers back
						if ( ignored.length > 0 ) {
							if ( span.length !== 0 ) {
								span.append( ignored );
							}
							else {
								cell.find( 'p' ).append( ignored );
							}
						}
					}
				}
			}

			info = $.pricingRowData( els[ i ] );

			// Skip rows without proper data
			if ( info.type === false || info.price === false || info.quantity === false ) {
				continue;
			}

			// Not a text row
			if ( info.type !== 6 ) {
				if ( info.type !== 1 ) {
					if ( $.isNumeric( info.price ) === true ) {
						// format price
						val = $.currencyDecimalFormat( $.formatCurrency( info.price, data.currency, data.format ) );
						cell = $( els[ i ] ).find( '> td' ).eq( 1 );

						// Only allow extra text in unit/qty rows)
						if ( info.type === 2 ) {
							parts = $.removeCurrencyFormat( cell[ 0 ].textContent, true );
							span = document.createElement( 'span' );

							// Handle HTML entities (browser parsers convert these). e.g. &euro;
							span.innerHTML = data.currency;

							if ( parts.length === 2 ) {
								prepend = parts[ 0 ];
								append = parts[ 1 ];
								currency = span.innerHTML;

								// If the last char of prepend is the same currency, remove it
								if ( prepend.substr( -( currency.length ) ) === currency ) {
									prepend = prepend.substr( 0, prepend.length - currency.length );
								}

								// If the first char of append is the same currency, remove it
								if ( append.substr( 0, currency.length ) === currency ) {
									append = append.substr( currency.length );
								}

								// We know what the "old" currency might have been (in the case of changes, etc)
								if ( cell[ 0 ].hasAttribute( 'data-currency' ) === true ) {
									el = document.createElement( 'span' );

									// Handle HTML entities (browser parsers convert these). e.g. &euro;
									el.innerHTML = cell[ 0 ].getAttribute( 'data-currency' );
									currency = el.innerHTML;

									// If the last char of prepend is the same currency, remove it
									if ( prepend.substr( -( currency.length ) ) === currency ) {
										prepend = prepend.substr( 0, prepend.length - currency.length );
									}

									// If the first char of append is the same currency, remove it
									if ( append.substr( 0, currency.length ) === currency ) {
										append = append.substr( currency.length );
									}
								}

								// Last chance catch for extra - sign that's added in formatCurrency above
								if ( prepend.substr( -1 ) === '-' ) {
									prepend = prepend.substr( 0, prepend.length - 1 );
								}

								val = prepend + val + append;
							}

							// Store the current currency for use later
							// Use the span created above so we catch the HTML entities in data.currency
							cell[ 0 ].setAttribute( 'data-currency', span.innerHTML );
						}
						else {
							// Pull this off
							cell[ 0 ].removeAttribute( 'data-currency' );
						}



						cell.replaceValue( val, 'div.rowmenu, span.fr-marker' );
					}

					input = $( els[ i ] ).find( '> td' ).eq( 2 ).find( 'input[type="text"]' );

					if ( input.length > 0 ) {
						input[ 0 ].value = info.quantity;
					}
				}

				if ( $.isNumeric( info.original_total ) === true ) {
					if ( has_strings === true ) {
						if ( info.type === 3 && data.strings.hasOwnProperty( 'month' ) === true ) {
							subtotal_string = ' / ' + data.strings.month;
						}
						else if ( info.type === 4 && data.strings.hasOwnProperty( 'year' ) === true ) {
							subtotal_string = ' / ' + data.strings.year;
						}
						else if ( info.type === 5 && data.strings.hasOwnProperty( 'hour' ) === true ) {
							subtotal_string = ' / ' + data.strings.hour;
						}
						else {
							subtotal_string = '';
						}
					}
					else {
						subtotal_string = '';
					}

					val = $.currencyDecimalFormat( $.formatCurrency( info.original_total, data.currency, data.format ) ) + subtotal_string;

					if ( info.discount !== false ) {
						if ( info.discount.enable === true ) {
							processed_val = $.currencyDecimalFormat( $.formatCurrency( info.total, data.currency, data.format ) ) + subtotal_string;

							label = info.discount.label + '(-';

							if ( info.discount.type === '%' ) {
								label += info.discount.value + info.discount.type;
							}
							else if ( info.discount.type === '$' ) {
								label += $.formatCurrency( info.discount.value, data.currency, data.format );
							}

							label += ')';

							el = $( els[ i ] ).find( '> td:last-of-type > *' );

							spans = $( els[ i ] ).find( '> td:last-of-type span.fr-immutable' );

							// if unbroken inline discount markup already exist.
							if ( spans.length === 3 && el.length === 1 && $( els[ i ] ).find( 'span.fr-immutable.fr-typeable' ).length === 1 ) {
								// Set pre inline discount value, use html here to remove br tags if need be
								// use replaceValue to update node value until prince fix https://www.princexml.com/forum/3/bugs
								$( spans[ 0 ] ).find( 'br' ).remove( );
								$( spans[ 0 ] ).replaceValue( val, '' );

								// Set new inline discount value
								$( spans[ 1 ] ).replaceValue( processed_val, '' );

								// Set new inline discount label
								$( spans[ 2 ] ).replaceValue( label, '' );
							}
							else {
								// Set pre inline discount value markup.
								val = '<span style="font-size: 12px; color: rgb(170, 170, 170);"><s><span class="fr-immutable fr-typeable">' + val + '</span></s></span><span class="fr-immutable">' + processed_val + '</span><span style="font-size: 14px; color: rgb(84, 171, 0);"><span class="fr-immutable">' + label + '</span></span>';

								$( els[ i ] ).find( '> td:last-of-type' ).html( '<p>' + val + '</p>' );
							}
						}
						else {
							// remove inline discount markup in the cell
							spans = $( els[ i ] ).find( '> td:last-of-type span.fr-immutable' );

							if ( spans.length > 0 ) {
								$( spans[ 0 ] ).closest( 'p' ).html( '' );
							}

							$( els[ i ] ).find( '> td' ).last( ).replaceValue( val, 'div.rowmenu, span.fr-marker' );
						}
					}
					else {
						$( els[ i ] ).find( '> td' ).last( ).replaceValue( val, 'div.rowmenu, span.fr-marker' );
					}
				}
			}
		}
	}

	return els;
};

/**
 * Format fee table footer
 *
 * Abstracted for use in both editor & PDF
 *
 * @param {JSONObject}	aData 	Object of data needed: strings( ), currency, format, total
 */

$.fn.formatPricingFooter = function( aData ) {
	var els = $( this ),
		data = aData || { },
		has_strings = ( data.hasOwnProperty( 'strings' ) === true ) ? true : false,
		re = /([\w\s]+[^()]+)/,
		i, len, j, len2, el, rows, row, td,
		subtotals, val, row_type, tax, discount, match, name;

	if ( data.hasOwnProperty( 'currency' ) === true && data.hasOwnProperty( 'format' ) === true && data.hasOwnProperty( 'subtotals' ) === true ) {
		for ( i = 0, len = els.length; i < len; i++ ) {
			el = $( els[ i ] );

			// Make sure we're in the footer
			if ( el.is( 'tfoot' ) === false ) {
				el = el.find( '> tfoot' );
			}

			// We have a footer
			if ( el.length > 0 ) {
				if ( parseInt( els[ i ].getAttribute( 'data-total' ), 10 ) === 0 ) {
					rows = el.find( '> tr' );
					subtotals = data.subtotals;

					for ( row_type in subtotals ) {
						if ( subtotals.hasOwnProperty( row_type ) === true ) {
							discount = 0;
							tax = 0;
							rows = el.find( 'tr[data-row-type="' + row_type + '"]' );

							if ( row_type === 'static' ) {
								rows = rows.add( el.find( 'tr:not([data-row-type])' ) );
							}

							// Update subtotal
							if ( rows.length > 1 ) {
								rows.first( ).find( '> td:last-child' ).replaceValue( $.currencyDecimalFormat( $.formatCurrency( subtotals[ row_type ], data.currency, data.format ) ), 'div.rowmenu' );
							}

							// Update discount
							for ( j = 0, len2 = rows.length; j < len2; j++ ) {
								if ( rows[ j ].getAttribute( 'data-rate-type' ) === 'discount' && ( rows[ j ].hasAttribute( 'data-rate-enable' ) === false || rows[ j ].getAttribute( 'data-rate-enable' ) === '1' ) ) {
									row = rows.eq( j );

									if ( rows[ j ].hasAttribute( 'data-rate-value-type' ) === false || rows[ j ].getAttribute( 'data-rate-value-type' ) === '%' ) {
										val = subtotals[ row_type ] * ( $.parseFloat( rows[ j ].getAttribute( 'data-rate-value' ) ) / 100 );
									}
									else {
										val = $.parseFloat( rows[ j ].getAttribute( 'data-rate-value' ) );

										// update currency symbol in discount name
										td = row.find( '> td:first-child' );
										match = re.exec( td.text( ) );
										name = ( match !== null ) ? match[ 1 ] : '';
										td.replaceValue( name + ' (-' + $.currencyDecimalFormat( $.formatCurrency( val, data.currency, data.format ) ) + ')', 'div.rowmenu' );
									}

									discount += val;

									if ( val < 0 ) {
										row.find( '> td:last-child' ).replaceValue( '-' + $.currencyDecimalFormat( $.formatCurrency( 0, data.currency, data.format ) ), 'div.rowmenu' );
									}
									else {
										row.find( '> td:last-child' ).replaceValue( '-' + $.currencyDecimalFormat( $.formatCurrency( val, data.currency, data.format ) ), 'div.rowmenu' );
									}
								}
							}

							// If discounted value is greater than price, set price to zero
							if ( subtotals[ row_type ] > discount ) {
								subtotals[ row_type ] -= discount;
							}
							else {
								subtotals[ row_type ] = 0;
							}

							// Update tax
							for ( j = 0, len2 = rows.length; j < len2; j++ ) {
								if ( rows[ j ].getAttribute( 'data-rate-type' ) === 'tax' && ( rows[ j ].hasAttribute( 'data-rate-enable' ) === false || rows[ j ].getAttribute( 'data-rate-enable' ) === '1' ) ) {
									if ( rows[ j ].hasAttribute( 'data-rate-value-type' ) === false || rows[ j ].getAttribute( 'data-rate-value-type' ) === '%' ) {
										val = subtotals[ row_type ] * ( $.parseFloat( rows[ j ].getAttribute( 'data-rate-value' ) ) / 100 );
									}
									else {
										val = $.parseFloat( rows[ j ].getAttribute( 'data-rate-value' ) );
									}

									tax += val;

									rows.eq( j ).find( '> td:last-child' ).replaceValue( $.currencyDecimalFormat( $.formatCurrency( val, data.currency, data.format ) ), 'div.rowmenu' );
								}
							}

							subtotals[ row_type ] += tax;

							// Update total
							rows.last( ).find( '> td:last-child' ).replaceValue( $.currencyDecimalFormat( $.formatCurrency( subtotals[ row_type ], data.currency, data.format ) ), 'div.rowmenu' );

							// Update strings
							if ( rows.length > 0 && has_strings === true ) {
								// String for subtotal
								if ( rows.filter( '[data-rate-type]' ).not( '[data-rate-enable="0"]' ).length > 0 && data.strings.hasOwnProperty( row_type + '_subtotal' ) === true ) {
									row = rows.first( );

									if ( row[ 0 ].hasAttribute( 'data-translate' ) === false || parseInt( row[ 0 ].getAttribute( 'data-translate' ), 10 ) === 1 ) {
										row.find( '> td:first-child' ).replaceValue( data.strings[ row_type + '_subtotal' ], 'div.rowmenu' );
									}
								}

								// String for total
								if ( data.strings.hasOwnProperty( row_type + '_total' ) === true ) {
									row = rows.last( );

									if ( row[ 0 ].hasAttribute( 'data-translate' ) === false || parseInt( row[ 0 ].getAttribute( 'data-translate' ), 10 ) === 1 ) {
										row.find( '> td:first-child' ).replaceValue( data.strings[ row_type + '_total' ], 'div.rowmenu' );
									}
								}
							}
						}
					}
				}
				else {
					el.find( '> tr > td' ).html( '<br/>' );
				}
			}
		}
	}
	return els;
};

/**
 * Get the link type from the passed link
 *
 * One of 'page', 'email', or 'url'
 *
 * @param {String} 	aHref 	The link to get the type from
 *
 * @return String
 */

$.getLinkType = function( aHref ) {
	var href = aHref || '',
		type;

	if ( href.charAt( 0 ) === '#' ) {
		type = 'page';
	}
	else if ( href.slice( 0, 7 ) === 'mailto:' ) {
		type = 'email';
	}
	else {
		type = 'url';
	}

	return type;
};

/**
 * Properly formats an unformatted link based on type given
 *
 * @param {String} aType 	Type to format link as
 * @param {String} aHref 	Href to format
 *
 * @return string
 */

$.formatLink = function( aType, aHref ) {
	var type = aType || '',
		href = aHref || '',
		detected_type = $.getLinkType( href ),
		allowed_variables = [
			'{proposal_link}',
			'{pdf_link}'
		];

	if ( type === 'url' && allowed_variables.indexOf( href ) === -1 ) {
		if ( href.substring( 0, 4 ) !== 'http' ) {
			if ( href.substring( 0, 3 ) !== 'www' ) {
				href = 'http://www.' + href;
			}
			else {
				href = 'http://' + href;
			}
		}
	}
	else if ( type === 'email' && detected_type !== 'email' ) {
		href = 'mailto:' + href;
	}

	return href;
};

/**
 * Generate contrast colour, see https://stackoverflow.com/a/11868398
 *
 * @param {String} aHexColor			hex value of color based on which we generate contrast color
 * @param {Integer} aThreshold			brightness level acts as threshold to determine using dark or bright color
 *
 * @return string
 */

$.contraster = function( aHexColor, aThreshold ) {
	var color = aHexColor,
		threshold = aThreshold || 140,
		r, g, b, yiq;

	// Remove leading # if found
	if ( color.substr( 0, 1 ) === '#' ) {
		color = color.substr( 1 );
	}

	r = parseInt( color.substr( 0, 2 ), 16 );
	g = parseInt( color.substr( 2, 2 ), 16 );
	b = parseInt( color.substr( 4, 2 ), 16 );

	yiq = ( ( r * 299 ) + ( g * 587 ) + ( b * 114 ) ) / 1000;

	// Although the sample code linked uses a threshold of 128 here, this produces
	// black text too often
	return ( yiq >= threshold ) ? 'black' : 'white';
};

/**
 * hexToHsb
 *
 * Convert hex value of a color to hsb
 *
 * @param aHex
 * @return Object
 */

$.hexToHsb = function( aHex ) {
	var rgb = $.hexToRgb( aHex ),
		hsb = { h: 0, s: 0, b: 0 },
		min = Math.min( rgb.r, rgb.g, rgb.b ),
		max = Math.max( rgb.r, rgb.g, rgb.b ),
		delta = max - min;

	hsb.b = max;
	hsb.s = ( max !== 0 ) ? 255 * delta / max : 0;

	if ( hsb.s !== 0 ) {
		if ( rgb.r === max ) {
			hsb.h = ( rgb.g - rgb.b ) / delta;
		}
		else if ( rgb.g === max ) {
			hsb.h = 2 + ( rgb.b - rgb.r ) / delta;
		}
		else {
			hsb.h = 4 + ( rgb.r - rgb.g ) / delta;
		}
	}
	else {
		hsb.h = -1;
	}

	hsb.h *= 60;

	if ( hsb.h < 0 ) {
		hsb.h += 360;
	}

	hsb.s *= 100 / 255;
	hsb.b *= 100 / 255;

	return hsb;
};

/**
 * hsbToHex
 *
 * Convert hsb value of a color to hex
 *
 * @param aHsb
 * @return String
 */

$.hsbToHex = function( aHsb ) {
	var rgb = { },
		h = parseInt( aHsb.h, 10 ),
		s = parseInt( aHsb.s * 255 / 100, 10 ),
		v = parseInt( aHsb.b * 255 / 100, 10 ),
		t1, t2, t3;

	if ( s === 0 ) {
		rgb.r = v;
		rgb.g = v;
		rgb.b = v;
	}
	else {
		t1 = v;
		t2 = ( 255 - s ) * v / 255;
		t3 = ( t1 - t2 ) * ( h % 60 ) / 60;

		if ( h === 360 ) {
			h = 0;
		}
		if ( h < 60 ) {
			rgb.r = t1;
			rgb.b = t2;
			rgb.g = t2 + t3;
		}
		else if ( h < 120 ) {
			rgb.g = t1;
			rgb.b = t2;
			rgb.r = t1 - t3;
		}
		else if ( h < 180 ) {
			rgb.g = t1;
			rgb.r = t2;
			rgb.b = t2 + t3;
		}
		else if ( h < 240 ) {
			rgb.b = t1;
			rgb.r = t2;
			rgb.g = t1 - t3;
		}
		else if ( h < 300 ) {
			rgb.b = t1;
			rgb.g = t2;
			rgb.r = t2 + t3;
		}
		else if ( h < 360 ) {
			rgb.r = t1;
			rgb.g = t2;
			rgb.b = t1 - t3;
		}
		else {
			rgb.r = 0;
			rgb.g = 0;
			rgb.b = 0;
		}
	}

	rgb = { r: Math.round( rgb.r ), g: Math.round( rgb.g ), b: Math.round( rgb.b ) };

	return $.rgbToHex( rgb );
};

/**
 * Get preview colors
 *
 * @param {String} aHexColor	hex value of color based on which we generate font and highlight colors
 *
 * @return Object
 */

$.getContrastColors = function( aHexColor ) {
	var colors = {
			font: $.contraster( aHexColor, 192 )
		},
		hsb = $.hexToHsb( aHexColor );

	if ( colors.font === 'black' ) {
		colors.font = '#000000';
	}
	else {
		colors.font = '#ffffff';
	}

	// when brightness > 50 use 5 as the difference for highlight color
	// when brightness <= 50 linearly increase the difference to 20
	hsb.b = ( hsb.b > 50 ) ? hsb.b - 5 : hsb.b + 5 + ( 50 - hsb.b ) / 10 * 3;
	colors.highlight = $.hsbToHex( hsb );

	return colors;
};

/**
 * Removes unnecessary spaces ( including nbsp )
 *
 * @param {String} aString
 *
 * @return {String} string
 */

$.removeSpace = function( aString ) {
	var string = aString || '';

	if ( string === '' ) {
		return string;
	}

	string = string.replace( /\u200B/g, '' );
	string = string.replace( /\s/g, '' );
	string = string.replace( /&nbsp;/g, '' );
	string = $.trim( string );

	return string;
};

/**
 * Get correct index of cell ( accounting for colspans )
 *
 * @param {DOMElement} aCell
 *
 * @return {Int} index
 */

$.getCellIndex = function( aCell ) {
	var cell = $( aCell ),
		index = cell.index( ),
		prev = cell.prevAll( 'td[colspan]' ),
		i, len;

	// Get Correct index if colspans are set
	for ( i = 0, len = prev.length; i < len; i++ ) {
		index += parseInt( $( prev[ i ] ).attr( 'colspan' ), 10 ) - 1;
	}

	return index;
};

/**
 * Upon having a set of cells (e.g.: element.find( 'td' )),
 * get the right one by having an index given by $.getCellIndex( )
 *
 * @param {DOMElement} aCells
 * @param {Integer} aIndex
 *
 * @return {DOMElement}
 */

$.getCellByIndex = function( aCells, aIndex ) {
	var cells = $( aCells ),
		index = parseInt( aIndex, 10 ),
		i, len, cell;

	for ( i = 0, len = cells.length; i < len; i++ ) {
		cell = $( cells[ i ] );

		if ( $.getCellIndex( cell ) !== index ) {
			continue;
		}

		return cell;
	}

	return $( );
};

/**
 * Toggle inputs (Enable/Disable Inputs and reset default value)
 *
 * @param {DOMElement} aInputs
 * @param {Boolean} aEnable
 */

$.toggleInputs = function( aInputs, aEnable ) {
	var inputs = $( aInputs ),
		enable = aEnable || false,
		input, default_value;

	if ( enable === true ) {
		$.fn.enable.apply( inputs );

		return;
	}

	$.fn.disable.apply( inputs );

	inputs.each( function( ) {
		input = $( this );
		default_value = input.attr( 'data-default' ) || '0';

		if ( typeof input.data === 'function' && input.data( 'autocomplete' ) !== undefined ) {
			input.data( 'autocomplete' ).select( default_value );
		}
		else if ( input.is( 'input[type=checkbox]' ) === true ) {
			input.prop( 'checked', false );
		}
		else {
			input.val( default_value );
		}
	} );
};

/**
 * Toggle Froala Buttons
 *
 * @param {DOMElement} aButton
 * @param {Boolean} aEnable
 */

$.toggleFroalaButton = function( aButton, aEnable ) {
	var button = $( aButton ),
		enable = aEnable || false;

	button.toggleClass( 'fr-disabled fr-no-refresh', enable === false );
	button.attr( 'aria-disabled', enable === false );
};

/**
 * Get cell below
 *
 * @param {DOMElement} aCell
 *
 * @return {DOMElement}
 *
 */

$.getCellBelow = function( aCell ) {
	var cell = $( aCell ),
		index = $.getCellIndex( cell ),
		row = cell.closest( 'tr' ),
		next_cells = row.next( 'tr' ).find( 'td' ),
		below = next_cells.eq( index );

	if ( $.getCellIndex( below ) !== index ) {
		below = $._getValidCellBelow( cell, index );
	}

	return below;
};

/**
 * Get valid cell below, accounting for colspans
 *
 * @param {DOMElement} aCell
 * @param {Integer} aIndex
 *
 * @return {DOMElement}
 */

$._getValidCellBelow = function( aCell, aIndex ) {
	var cell = $( aCell ),
		index = parseInt( aIndex, 10 ) || $.getCellIndex( cell.index( ) ),
		row = cell.closest( 'tr' ),
		cells = row.next( 'tr' ).find( 'td' );

	return cells.filter( function( ) {
		var el = $( this );

		if ( $.getCellIndex( el.next( ) ) > index ) {
			return el;
		}
	} );
};

/**
 * Capitalize first letter
 *
 * @param {String} aString
 *
 * @return {String}
 */

$.ucfirst = function( aString ) {
	var string = aString || '';

	return string.charAt( 0 ).toUpperCase( ) + string.slice( 1 );
};

/**
 * Find editable paragraph on element
 *
 * @param {DOMElement} aElement
 *
 * @return {DOMElement}
 */

$.getEditableParagraph = function( aElement ) {
	return $( aElement ).find( 'p:not([contenteditable="false"])' );
};

/**
 * Returns a slug from a given string.
 * E.g.: My string is béautiful! -> my-string-is-beautiful
 *
 * @param {String} aString
 * @param {String} aSeparator
 *
 * @return {String}
 */

$.slugify = function( aString, aSeparator ) {
	var str = aString || '',
		sep = aSeparator || '-',
		from, to, i, from_regex;

	if ( str === '' ) {
		return str;
	}

	str = str.replace( /^\s+|\s+$/g, '' );
	str = str.toLowerCase( );

	from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
	to = 'aaaaeeeeiiiioooouuuunc------';

	for ( i = 0; i < from.length; i++ ) {
		from_regex = new RegExp( from.charAt( i ), 'g' );
		str = str.replace( from_regex, to.charAt( i ) );
	}

	str = str.replace( /[^a-z0-9-]/g, '' );
	str = str.replace( /\s+/g, sep );
	str = str.replace( /-+/g, sep );

	return str;
};

/**
 * Replace non numeric with empty string on a given value
 *
 * @param {String} value
 *
 * @return {String}
 */

$.numericOnly = function( value ) {
	return value.replace( /[^0-9\.]+/g, '' );
};

/**
 * Replace non numeric with empty string on element
 *
 * @param {DOMElement} aElement
 *
 * @return void
 */

$.applyNumericValueOnElement = function( aElement ) {
	$( aElement ).val( $.numericOnly( $( aElement ).val( ) ) );
};

/**
 * Returns if cells are on the same table or not.
 *
 * @param {DOMElement} aCell
 * @param {DOMElement} bCell
 */

$.isOnSameTable = function( aCell, bCell ) {
	return $( aCell ).closest( 'table' ).attr( 'data-id' ) === $( bCell ).closest( 'table' ).attr( 'data-id' );
};

/**
 * Trims the given element(s) class attribute
 *
 * @param {DOMElement} aElement
 *
 * @return {DOMElement}
 */

$.trimClass = function( aElement ) {
	var element = $( aElement ),
		_class = element.attr( 'class' );

	if ( _class === undefined ) {
		return element;
	}

	element.attr( 'class', _class.trim( ) );

	return element;
};

/**
 * Check if the index of a element content is on the last line of an element
 *
 * @param {HTMLElement} aElement
 * @param {Int} aIndex
 *
 * @return {Boolean}
 */

$.isOnLastLineOfElement = function( aElement, aIndex ) {
	var el = $( aElement ),
		index = parseInt( aIndex, 10 ) || 0,
		text_metrics = $.getTextMetrics( el ),
		start, end, lines;

	if ( text_metrics.has_one_line === true ) {
		return true;
	}

	lines = text_metrics.num_of_lines;
	end = parseInt( el[ 0 ].textContent.length, 10 );
	start = end - parseInt( end / lines, 10 );

	if ( index >= start && index <= end ) {
		return true;
	}

	return false;
};

/**
 * Check if the index of a element content is on the first line of an element
 *
 * @param {HTMLElement} aElement
 * @param {Int} aIndex
 *
 * @return {Boolean}
 */

$.isOnFirstLineOfElement = function( aElement, aIndex ) {
	var el = $( aElement ),
		index = parseInt( aIndex, 10 ) || 0,
		text_metrics = $.getTextMetrics( el ),
		start, end, lines;

	if ( text_metrics.has_one_line === true ) {
		return true;
	}

	lines = text_metrics.num_of_lines;
	end = parseInt( el[ 0 ].textContent.length, 10 );
	end = parseInt( end / lines, 10 );
	start = 0;

	if ( index >= start && index <= end ) {
		return true;
	}

	return false;
};

/**
 * Get number of lines of element
 *
 * @param {HTMLElement} aElement
 *
 * @return {Int}
 */

$.getNumberOfLines = function( aElement ) {
	var el = $( aElement ),
		lines = 0;

	if ( el.length === 0 ) {
		return lines;
	}

	lines = parseInt( el.height( ), 10 ) / parseInt( el.css( 'line-height' ), 10 );
	lines = Math.floor( lines );

	return lines;
};

/**
 * Get direction of arrow key code
 *
 * @param {Int} aKeycode
 *
 * @return {String} position
 */

$.getArrowKeyDirection = function( aKeycode ) {
	var key_code = aKeycode || 0,
		position = '';

	if ( $.FE.KEYCODE.ARROW_UP === key_code ) {
		position = 'up';
	}
	else if ( $.FE.KEYCODE.ARROW_DOWN === key_code ) {
		position = 'down';
	}
	else if ( $.FE.KEYCODE.ARROW_LEFT === key_code ) {
		position = 'left';
	}
	else if ( $.FE.KEYCODE.ARROW_RIGHT === key_code ) {
		position = 'right';
	}

	return position;
};

/**
 * Get width of text ( in px )
 *
 * @param {HTMLElement} aElement
 *
 * @return {Float} width
 */

$.getTextWidth = function( aElement ) {
	var el = $( aElement ),
		width = 0,
		styles = [
			'font-size',
			'font-style',
			'font-weight',
			'font-family',
			'line-height',
			'text-transform',
			'letter-spacing',
			'padding',
			'margin'
		],
		div;

	if ( el.length === 0 ) {
		return width;
	}

	div = document.createElement( 'div' );

	document.body.appendChild( div );

	div = $( div );

	div.css( {
		'position': 'absolute',
		'float': 'left',
		'white-space': 'nowrap',
		'visibility': 'hidden',
		'display': 'none'
	} );

	div.html( el.html( ) );

	styles.forEach( function( string ) {
		div.css( string, el.css( string ) );
	} );

	width = div.outerWidth( );

	div.remove( );

	return width;
};

/**
 * Find editable elements on element
 *
 * @param {DOMElement} aElement
 *
 * @return {DOMElement}
 */

$.getEditableElements = function( aElement ) {
	return $( aElement ).find( 'p, li' ).filter( '[contenteditable!="false"]' );
};

/**
 * Get text metrics from element's text
 *
 * @param {DOMElement} aElement
 *
 * @return {Object}
 */

$.getTextMetrics = function( aElement ) {
	var el = $( aElement ),
		metrics = {
			'length': 0,
			'width': 0,
			'char_per_line': 0,
			'has_one_line': false
		};

	if ( el.length === 0 ) {
		return metrics;
	}

	metrics.length = parseInt( el.text( ).length, 10 );
	metrics.width = $.getTextWidth( el );

	metrics.char_per_line = parseFloat( metrics.length / metrics.width ).toFixed( 2 );
	metrics.char_per_line = Math.round( metrics.char_per_line * el.width( ) );

	metrics.has_one_line = metrics.length <= metrics.char_per_line;
	metrics.num_of_lines = Math.ceil( metrics.length / metrics.char_per_line );

	return metrics;
};

/**
 * Get values of column of array
 *
 * @param {HTMLElement} aArray
 * @param {String} aColumn
 *
 * @return {Array}
 */

$.arrayColumn = function( aArray, aColumn ) {
	var array = aArray || [ ],
		column = aColumn || '';

	return array.map( function( el ) {
		return el[ column ];
	} );
};

/**
 * Ignore Element's child tag selector
 *
 * @param {HTMLElement} aElement
 * @param {String} aTag
 *
 * @return {HTMLElement}
 */

$.ignore_child = function( aElement, aTag ) {
	var element = $( aElement ),
		tag = aTag || '>*';

	return element.clone( ).find( tag ).remove( ).end( );
};

/**
 * Filter unique elements by data-id attribute
 *
 * @param {HTMLElement} aElements
 *
 * @return {HTMLElement}
 */

$.filterUniqueElementsByDataId = function( aElements ) {
	var elements = $( aElements ),
		unique_elements = $( );

	$.each( elements, function( aIndex, aElement ) {
		var element_id = $( aElement ).attr( 'data-id' ),
			is_duplicated_element = unique_elements.filter( '[data-id="' + element_id + '"]' ).length > 0;

		if ( is_duplicated_element ) {
			return;
		}

		unique_elements.push( aElement );
	} );

	return unique_elements;
};

/**
 * Get numeral from string
 *
 * @param {String} aString
 *
 * @return {String}
 */

$.getNumeralFromString = function( aString ) {
	var string = aString || '';

	return string.replace( /[^0-9\.]+/g, '' );
};

define("plugins", ["jquery"], (function (global) {
    return function () {
        var ret, fn;
        return ret || global.Plugins;
    };
}(this)));

